import type { ArchiveOfficialRequest, TurnoverPreviewItem } from './apiClient';

export interface BulkArchiveRequest extends ArchiveOfficialRequest {
  key: string;
  officialId: string;
  officialName: string;
  source: string;
  state: string | null;
  officeName: string | null;
  chamber: string | null;
  district: string | null;
  reason: ArchiveOfficialRequest['reason'];
  replaced_by_official_id: string | null;
}

function normalizeArchiveReason(reason: TurnoverPreviewItem['reason']): string {
  return reason === 'seat_replaced' ? 'replaced_after_election' : 'missing_from_latest_roster';
}

export function buildBulkArchiveRequests(
  items: TurnoverPreviewItem[],
  successorDrafts: Record<string, string>,
): BulkArchiveRequest[] {
  const seen = new Set<string>();
  const requests: BulkArchiveRequest[] = [];

  for (const item of items) {
    const key = `${item.source}:${item.officialId}`;
    if (seen.has(key)) continue;
    seen.add(key);

    const rawDraft = successorDrafts[key];
    const successorOfficialId = (rawDraft !== undefined ? rawDraft : (item.replacedByOfficialId ?? '')).trim() || null;

    requests.push({
      key,
      officialId: item.officialId,
      officialName: item.officialName,
      source: item.source,
      state: item.state,
      officeName: item.officeName,
      chamber: item.chamber,
      district: item.district,
      reason: normalizeArchiveReason(item.reason),
      replaced_by_official_id: successorOfficialId,
    });
  }

  return requests;
}
